import { red } from '@material-ui/core/colors';
import { createTheme } from '@material-ui/core/styles';

// A custom theme for this app
const theme = createTheme({
  typography: {
    button: {
      textTransform: 'none',
    },
  },
  palette: {
    // type: 'dark',
    background: {
      default: '#fff',
    },
    error: {
      main: red.A400,
    },
    text: {
      secondary: 'rgba(0, 0, 0, 0.54)',
    },
    primary: {
      main: '#70AD47',
      contrastText: '#fff', // button text white instead of black
    },
    secondary: {
      main: '#2F491D',
      contrastText: '#fff', // button text white instead of black
    },
  },
});

export default theme;
